import Axios from "axios";
import Config from "@/config/index.js";
import { isAndroid } from "@/utils/isTerminal.js";
import { getToken, removeToken, removeUserInfo, deviceInfo } from "@/utils/common.js";
import { Toast } from "vant";
import bus from "@/utils/eventBus.js";

const service = Axios.create({
  baseURL: Config.apiUrl + "/" + Config.apiPrefix,
  headers: {
    Accept: "*/*",
  },
  timeout: Config.timeout,
});

service.interceptors.request.use(
  (config) => {
    if (config.showLoading) {
      window.LoadingInstance = Toast.loading({
        mask: true,
        message: "加载中...",
        duration: 0,
      });
    }
    // 跟admin_operation不一样：H5/护士加用户侧 businessSource固定是1，
    // terminalPlatform按安卓/iOS动态判断(照抄campaign-voting-star的规则)
    config.headers["businessSource"] = 1;
    config.headers["terminalPlatform"] = isAndroid ? 3 : 2;
    config.headers["requestId"] = new Date().getTime();
    config.headers["Authorization"] = getToken() || "";
    // 设备类型(PHONE/PC)，照抄campaign-voting-star的规则，跟登录表单里那个"loginType:1"
    // (代表登录方式，1=手机验证码登录)不是一回事，这个是全局请求头
    config.headers["loginType"] = deviceInfo();
    // TODO 待确认：原项目里这个写死是"MiniProgram"，咱们这边是普通H5不是小程序，
    // 先原样保留观察后端会不会有问题，如果后端按这个字段区分小程序/H5做不同逻辑，
    // 需要改成一个更准确的值，这条等联调的时候留意
    config.headers["User-Env"] = "MiniProgram";
    if (config.noToken) {
      config.headers["Authorization"] = "";
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (res) => {
    if (window.LoadingInstance) {
      setTimeout(() => {
        window.LoadingInstance.clear();
      }, 300);
    }
    if (res.status !== 200) {
      return Promise.reject("响应非200！");
    }
    if (res.config.closeAllIntercept) {
      return res.data;
    }
    if (res.data.code == 100003 || res.data.code == 100004) {
      // token无效/过期：清掉本地登录态，喊一声让App弹登录窗，不是MPA那种整页跳转
      removeToken();
      removeUserInfo();
      bus.$emit("show-login");
      return Promise.reject(res.data);
    }
    if (res.data.code != 100000) {
      setTimeout(() => {
        Toast(res.data.msg || res.data.message || "操作失败");
      }, 200);
      return Promise.reject(res.data);
    }
    return res.data.data;
  },
  (error) => {
    if (window.LoadingInstance) {
      window.LoadingInstance.clear();
    }
    return Promise.reject(error);
  }
);

export default service;
